import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pagination-controls',
  standalone: true,
  templateUrl: './pagination-controls.component.html',
  styleUrl: './pagination-controls.component.scss'
})
export class PaginationControlsComponent {
  @Input() pageSizeOptions: number[] = [];
  @Input() pageSize = 4;
  @Input() currentPage = 1;
  @Input() totalPages = 1;
  @Input() canGoPrev = false;
  @Input() canGoNext = false;

  @Output() pageSizeChange = new EventEmitter<string>();
  @Output() prevPage = new EventEmitter<void>();
  @Output() nextPage = new EventEmitter<void>();
}
